import { useEffect } from "react";


const useDisableAutoZoomWithModal = (isModalOpen) => {
    useEffect(() => {
      // Only apply when modal is visible
      if (!isModalOpen) return;
      
      const disableAutoZoom = () => {
        const viewport = document.querySelector('meta[name="viewport"]');
        if (viewport) {
          viewport.setAttribute('content', 
            'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no');
        } else {
          const metaTag = document.createElement('meta');
          metaTag.name = 'viewport';
          metaTag.content = 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no';
          document.getElementsByTagName('head')[0].appendChild(metaTag);
        }
      };
  
      disableAutoZoom();
      window.addEventListener('orientationchange', disableAutoZoom);
      
      return () => {
        window.removeEventListener('orientationchange', disableAutoZoom);
        
        // Restore original viewport when modal closes
        const origViewport = document.querySelector('meta[name="viewport"]');
        if (origViewport) {
          origViewport.setAttribute('content', 'width=device-width, initial-scale=1');
        }
      };
    }, [isModalOpen]);
  };

  export default useDisableAutoZoomWithModal;